module.exports = __webpack_public_path__ + "static/media/slider_3_collab_user_en.74d45438.svg";